<template>
  <div class="header">
    <div class="header__container content-container">
      <template v-if="props.showBackButton">
        <div class="header__back-button" @click="handleBackClick">
          <ion-icon :icon="chevronBackOutline" />
        </div>
      </template>

      <div v-if="title" class="header__title subtitle">
        {{ title }}
      </div>
      <div
        v-if="props.showAvatar || $slots.rightBlock"
        class="header__right-block"
      >
        <slot name="rightBlock" />
        <user-avatar
          v-if="props.showAvatar"
          :user="userStore.user"
          clickable
          @click="router.push({ name: 'MyProfile' })"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { IonIcon, useIonRouter } from '@ionic/vue';
import { chevronBackOutline } from 'ionicons/icons';
import { RouteLocationRaw, useRouter } from 'vue-router';

import UserAvatar from '@/components/UserAvatar.vue';

interface HeaderProps {
  title?: string | null;
  showBackButton?: boolean;
  showAvatar?: boolean;
  isLoading?: false | boolean;
  backgroundColor?: '#fff' | string;
  to?: RouteLocationRaw | null;
}

const props = withDefaults(defineProps<HeaderProps>(), {
  showBackButton: true,
  showAvatar: true,
});

const router = useRouter();
const ionRouter = useIonRouter();
const userStore = useUserStore();

function handleBackClick() {
  if (props.to) {
    ionRouter.navigate(props.to, 'back', 'push');
    return;
  }
  if (
    !router.options.history.state.back ||
    (router.options.history.state.back === '/auth' && userStore.isLogged)
  ) {
    return router.push({ name: 'Feed' });
  }
  return router.back();
}
</script>

<style lang="scss" scoped>
.header {
  margin-top: 22px;
  padding-bottom: 22px;
  padding-top: var(--ion-safe-area-top);

  @media (max-width: 400px) {
    .header__title {
      font-size: 1.3rem;
    }
  }

  &__container {
    display: flex !important;
    align-items: center !important;
    flex-direction: row !important;
    justify-content: flex-start !important;
    z-index: unset !important;
  }

  &__title {
    font-size: 1.6rem;
    color: #172659;

    &:not(:first-child) {
      margin-left: 10px;
    }
  }

  &__back-button {
    /* background: #fff; */
    width: 32px;
    min-width: 32px;
    height: 32px;
    /* border-radius: 100%; */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: var(--ion-color-header);
    cursor: pointer;

    :deep(ion-icon) {
      font-size: 25px;
    }
  }

  &__right-block {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
}
</style>
